<template>
  <div :class="{ 'bg-white': !nightMode, 'bg-dark': nightMode }" class="pt-5 p-st home-section">
    <!-- Custom Particle Effects -->
    <div class="particle-effects">
      <!-- Stars -->
      <div class="star" :class="{ 'night-mode': nightMode }" style="left: 10%; top: 20%; animation-delay: 0s;"></div>
      <div class="star" :class="{ 'night-mode': nightMode }" style="left: 25%; top: 15%; animation-delay: 1s;"></div>
      <div class="star" :class="{ 'night-mode': nightMode }" style="left: 40%; top: 30%; animation-delay: 0.5s;"></div>
      <div class="star" :class="{ 'night-mode': nightMode }" style="left: 60%; top: 10%; animation-delay: 1.5s;"></div>
      <div class="star" :class="{ 'night-mode': nightMode }" style="left: 75%; top: 25%; animation-delay: 0.8s;"></div>
      <div class="star" :class="{ 'night-mode': nightMode }" style="left: 85%; top: 35%; animation-delay: 2s;"></div>
      <div class="star" :class="{ 'night-mode': nightMode }" style="left: 15%; top: 45%; animation-delay: 1.2s;"></div>
      <div class="star" :class="{ 'night-mode': nightMode }" style="left: 35%; top: 50%; animation-delay: 0.3s;"></div>
      <div class="star" :class="{ 'night-mode': nightMode }" style="left: 55%; top: 40%; animation-delay: 1.8s;"></div>
      <div class="star" :class="{ 'night-mode': nightMode }" style="left: 70%; top: 55%; animation-delay: 0.7s;"></div>
      <div class="star" :class="{ 'night-mode': nightMode }" style="left: 90%; top: 60%; animation-delay: 2.5s;"></div>
      <div class="star" :class="{ 'night-mode': nightMode }" style="left: 5%; top: 65%; animation-delay: 1.8s;"></div>
      <div class="star" :class="{ 'night-mode': nightMode }" style="left: 65%; top: 70%; animation-delay: 0.9s;"></div>
      <div class="star" :class="{ 'night-mode': nightMode }" style="left: 45%; top: 75%; animation-delay: 2.1s;"></div>
      <div class="star" :class="{ 'night-mode': nightMode }" style="left: 20%; top: 80%; animation-delay: 1.4s;"></div>
      
      <!-- Meteors -->
      <div class="meteor" :class="{ 'night-mode': nightMode }" style="left: 20%; animation-delay: 2s;"></div>
      <div class="meteor" :class="{ 'night-mode': nightMode }" style="left: 60%; animation-delay: 6s;"></div>
      <div class="meteor" :class="{ 'night-mode': nightMode }" style="left: 80%; animation-delay: 10s;"></div>
      <div class="meteor" :class="{ 'night-mode': nightMode }" style="left: 30%; animation-delay: 14s;"></div>
      
      <!-- Floating particles -->
      <div class="floating-particle" :class="{ 'night-mode': nightMode }" style="left: 15%; animation-delay: 1s;"></div>
      <div class="floating-particle" :class="{ 'night-mode': nightMode }" style="left: 30%; animation-delay: 4s;"></div>
      <div class="floating-particle" :class="{ 'night-mode': nightMode }" style="left: 45%; animation-delay: 8s;"></div>
      <div class="floating-particle" :class="{ 'night-mode': nightMode }" style="left: 65%; animation-delay: 12s;"></div>
      <div class="floating-particle" :class="{ 'night-mode': nightMode }" style="left: 80%; animation-delay: 16s;"></div>
      <div class="floating-particle" :class="{ 'night-mode': nightMode }" style="left: 10%; animation-delay: 20s;"></div>
      <div class="floating-particle" :class="{ 'night-mode': nightMode }" style="left: 70%; animation-delay: 24s;"></div>
    </div>
    <div class="container" data-aos="fade" data-aos-once="true" data-aos-duration="1000" style="position: relative; z-index: 2;">
      <div class="row align-items-center">
        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12 text-center">
          <img :src="picture" class="rounded-img" />
        </div>

        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12 pt-5">
          <span class="home-title" :class="{ pgray: !nightMode, 'text-light': nightMode }">Dive into My
            Portfolio!</span>
          <div>
            <p v-html="description"></p>
          </div>
          <div class="text-center pb-4">
            <button class="btn btn-outline-secondary mx-2 " @click="open('linkedin')" v-tooltip.bottom="'LinkedIn'">
              <i class="fab fa-linkedin"></i>
            </button>
            <button class="btn btn-outline-secondary mx-2" @click="open('github')" v-tooltip.bottom="'GitHub'">
              <i class="fab fa-github"></i>
            </button>
            <button class="btn btn-outline-secondary mx-2" @click="open('resume')" v-tooltip.bottom="'Resume'">
              <i class="fa fa-file"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import info from "../../info";

export default {
  name: "Home",
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      picture: info.flat_picture,
      description: info.description,
      name: info.name,
      linkedin: info.links.linkedin,
      github: info.links.github,
      resume: info.links.resume
    };
  },
  methods: {
    open(link) {
      switch (link) {
        case "linkedin":
          window.open(this.linkedin, "_blank");
          break;
        case "github":
          window.open(this.github, "_blank");
          break;
        case "resume":
          window.open(this.resume, "_blank");
          break;
      }
    },
  },
};
</script>

<style scoped>
.home-section {
  position: relative;
  overflow: hidden;
}

/* Particle Effects */
.particle-effects {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

/* Stars */
.star {
  position: absolute;
  width: 5px;
  height: 5px;
  background: #759CC9;
  border-radius: 50%;
  opacity: 1;
  animation: twinkle 4s ease-in-out infinite;
  box-shadow: 0 0 10px #759CC9, 0 0 15px rgba(117, 156, 201, 0.5);
}

.star.night-mode {
  background: #ffffff;
  box-shadow: 0 0 10px #ffffff, 0 0 20px rgba(255, 255, 255, 0.7);
}

@keyframes twinkle {
  0%, 100% { 
    opacity: 0.4; 
    transform: scale(1); 
  }
  50% { 
    opacity: 1; 
    transform: scale(1.3); 
  }
}

/* Meteors */
.meteor {
  position: absolute;
  width: 7px;
  height: 7px;
  background: radial-gradient(circle, #fff 0%, #759CC9 60%, transparent 100%);
  border-radius: 50%;
  box-shadow: 0 0 20px #759CC9, 0 0 30px #759CC9, 0 0 40px rgba(117, 156, 201, 0.6);
  top: -150px;
  animation: meteorFall 6s linear infinite;
}

.meteor.night-mode {
  background: radial-gradient(circle, #fff 0%, #fff 60%, transparent 100%);
  box-shadow: 0 0 20px #ffffff, 0 0 30px #ffffff, 0 0 40px rgba(255, 255, 255, 0.6);
}

.meteor::before {
  content: '';
  position: absolute;
  top: 3.5px;
  left: 3.5px;
  width: 120px;
  height: 4px;
  background: linear-gradient(90deg, transparent, #759CC9, rgba(117, 156, 201, 0.7), rgba(117, 156, 201, 0.3), transparent);
  border-radius: 50%;
  transform: translateX(-60px) translateY(-2px) rotate(45deg);
  opacity: 1;
}

.meteor.night-mode::before {
  background: linear-gradient(90deg, transparent, #ffffff, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.3), transparent);
}

@keyframes meteorFall {
  0% {
    transform: translateY(-200px) translateX(-200px);
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  100% {
    transform: translateY(calc(100vh + 300px)) translateX(300px);
    opacity: 0;
  }
}

/* Floating particles */
.floating-particle {
  position: absolute;
  width: 6px;
  height: 6px;
  background: rgba(117, 156, 201, 0.9);
  border-radius: 50%;
  bottom: -30px;
  animation: floatUp 30s ease-out infinite;
  box-shadow: 0 0 12px rgba(117, 156, 201, 0.7), 0 0 25px rgba(117, 156, 201, 0.4);
}

.floating-particle.night-mode {
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 0 12px rgba(255, 255, 255, 0.7), 0 0 25px rgba(255, 255, 255, 0.4);
}

@keyframes floatUp {
  0% {
    transform: translateY(0) translateX(0) scale(1);
    opacity: 0;
  }
  8% {
    opacity: 1;
  }
  92% {
    opacity: 0.9;
  }
  100% {
    transform: translateY(-130vh) translateX(50px) scale(0.1);
    opacity: 0;
  }
}

/* Background glow effect */
.home-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(ellipse at center, rgba(117, 156, 201, 0.05) 0%, transparent 70%);
  pointer-events: none;
  z-index: 0;
}

.home-title {
  font-size: 32px;
  font-weight: 500;
}

img {
  max-width: 800px;
  max-height: 500px;
  margin-top: 80px;
  transform: rotateY(180deg);
}

@media only screen and (max-width: 580px) {
  img {
    object-fit: cover;
    border-radius: 50%;
    height: 200px;
    width: 200px;
    margin-top: 10px;
    margin-bottom: 10px;
    border: 2px solid rgb(205, 205, 205);
  }
}

.fa {
  font-size: 15px;
}

.btn {
  border-color: #759CC9;
  color: #759CC9;
}

.btn:hover {
  background-color: #759CC9;
  border-color: #759CC9;
  color: white;
}

.btn:focus {
  background-color: #759CC9;
  border-color: #759CC9;
  color: white;
}

.btn:focus {
  outline: none !important;
}

p {
  text-align: justify;
  font-weight: 400;
}

.rounded-img {
  border-radius: 10px;
  /* Anda dapat mengubah nilai sesuai dengan seberapa bulat yang Anda inginkan */
}
</style>